module.exports = __webpack_public_path__ + "img/turbo_on.0dab67a0.png";